<template>
  <v-card class="pa-3" width="480">
    <v-card-title class="headline">
      <font-awesome-icon
        class="mr-2"
        :style="{ color: '#424242' }"
        size="lg"
        :icon="['fal', 'exchange']"
      />
      Cambiar Contraseña
    </v-card-title>
    <v-card-text>
      <!-- <v-flex d-flex mb-3 pl-3 py-1 class="header-card">
        <v-flex>
          <h2>Cambiar Clave</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-flex>
          <v-btn
            class="close-btn-style"
            color="white orange--text"
            small
            absolute
            depressed
            top
            right
            fab
            @click="cancel"
          >
            <v-icon size="24">close</v-icon>
          </v-btn>
        </v-flex>
      </v-flex> -->
      <!-- USER TO CHANGE PASSWORD -->
      <v-flex v-if="userToChangePassword !== null" pa-3>
        <v-flex>
          Al usuario relacionado con el email:
        </v-flex>
        <v-flex class="subheading font-weight-bold">
          {{ userToChangePassword.email }}
        </v-flex>
        <v-flex>
          le vas a cambiar la clave de forma manual.
        </v-flex>
      </v-flex>
      <!-- FORM -->
      <v-form class="px-3" v-model="valid" ref="form" lazy-validation>
        <!-- NEW PASSWORD 1 -->
        <!-- :rules="[v => !!v || 'Item requerido']" -->
        <v-text-field
          box
          label="Nueva Clave"
          v-model="pass1"
          :append-icon="showPass1 ? 'visibility' : 'visibility_off'"
          :type="showPass1 ? 'text' : 'password'"
          required
          :rules="passRules"
          color="#C46D24"
          clearable
          @click:append="showPass1 = !showPass1"
          @input="resetMessage"
        ></v-text-field>
        <!-- NEW PASSWORD 2 -->
        <v-text-field
          box
          label="Confirmar Nueva Clave"
          v-model="pass2"
          :rules="[v => !!v || 'Item requerido']"
          :append-icon="showPass2 ? 'visibility' : 'visibility_off'"
          :type="showPass2 ? 'text' : 'password'"
          required
          color="#C46D24"
          clearable
          @click:append="showPass2 = !showPass2"
          @input="resetMessage"
        ></v-text-field>
        <v-flex v-if="notMatch" py-2>
          <p>
            Por favor verificar <b>Nueva Clave</b> y
            <b>Confirmar Nueva Clave</b>
            porque no coinciden
          </p>
        </v-flex>
        <!-- <v-divider class="my-2"></v-divider> -->
        <!-- SUBMIT -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize button-width"
            color="error"
            @click="cancel"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'times-circle']"
            />
            Cancelar
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            class="text-capitalize button-width"
            color="#466EA5"
            @click="submit"
            :dark="valid"
            :disabled="!valid"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'paper-plane']"
            />
            Enviar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      showPass1: false,
      showPass2: false,
      passRules: [
        v => !!v || "Item requerido",
        v =>
          /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/.test(
            v
          ) ||
          "Debe contener por lo menos 8 caracteres, un número, una minúscula y una mayúscula"
      ],
      notMatch: false,
      pass1: "",
      pass2: "",
      valid: false
    };
  },
  computed: {
    ...mapGetters(["userToChangePassword"])
  },
  methods: {
    ...mapActions(["changeUserPasswordAdmin", "updatePassword"]),
    resetMessage() {
      this.notMatch = false;
    },
    submit() {
      if (this.$refs.form.validate()) {
        const data = {
          pass1: this.pass1,
          pass2: this.pass2
        };
        if (this.pass1 === this.pass2) {
          if (this.userToChangePassword === null) this.updatePassword(data);
          else this.changeUserPasswordAdmin(data);
        } else this.notMatch = true;
      } else console.log("VERIFY FORM!");
    },
    cancel() {
      this.pass1 = "";
      this.pass2 = "";
      this.$store.commit("SET_USER_TO_CHANGE_PASSWORD", null);
      this.$store.commit("SET_DIALOG_CHANGE_PASSWORD", false);
    }
  }
}
</script>

<style lang="stylus" scoped>
h2
  font-size 32px
  color white

 .close-btn-style
  margin-top 27px

.header-card
  background-color #C46D24
</style>
